<template>
  <div id="body-fat-index">
    <form @submit.prevent="calculate">
      <div>
        <input type="number" min="0" v-model="age" placeholder="Wiek (lat)">
      </div>
      <div>
        <select v-model="gender">
          <option value="">Płeć</option>
          <option value="m">mężczyzna</option>
          <option value="k">kobieta</option>
        </select>
      </div>
      <div>
        <input type="number" v-model="weight" min="0" placeholder="Waga (kg)">
      </div>
      <div>
        <input type="number" v-model="height" min="0" placeholder="Wzrost (cm)">
      </div>
      <div>
        <select v-model="goal">
          <option value="">Cel</option>
					<option value="fat-loss">Utrata tkanki tłuszczowej</option>
					<option value="maintenance">Utrzymanie wagi</option>
					<option value="muscle-gain">Budowanie masy mięśniowej</option>
        </select> 
      </div>
      <div>
        <select v-model="activity">
          <option value="">Poziom aktywności</option>
          <option value="lightly-active">Mało aktywny (umiarkowane ćwiczenia, siedzący tryb pracy)</option>
          <option value="moderately-active">Umiarkowanie aktywny (intensywne ćwiczenia, ale siedzący tryb pracy)</option>
          <option value="very-active">Aktywny (umiarkowane ćwiczenia i praca w ruchu)</option>
          <option value="extra-active">Bardzo aktywny (intensywne ćwiczenia i praca w ruchu)</option>
				</select>
      </div>
      <input type="submit" value="Oblicz">
    </form>
    <div v-if="displayFields">
      <div class="calories-burned">
        Dzienne zapotrzebowanie kaloryczne:
        <div>{{this.result}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaloriesDemand',
   methods: {
    calculate: function() {
      let result = 0;

			if ( this.gender === 'm' ) {
				result = ( (this.weight * 10) + (this.height * 6.25) - (this.age * 5) + 5 );
			}
			else if ( this.gender === 'k' ) {
				result = ( (this.weight * 10) + (this.height * 6.25) - (this.age * 5) - 161 );
			}

			switch (this.activity) {
				case 'lightly-active':    result = Math.round(result * 1.1); break;
				case 'moderately-active': result = Math.round(result * 1.3); break;
				case 'very-active':       result = Math.round(result * 1.5); break;
				case 'extra-active':      result = Math.round(result * 1.7); break;
			}

			switch (this.goal) {
				case 'fat-loss':
					if ( result <= 2000 ) { result = result * 0.9; }
					if ( result > 2000 ) { result = result * 0.8; }
					break;
				case 'maintenance':
					break;
				case 'muscle-gain':
					result += 500;
					break;
			}

      this.result = result;
      this.displayFields = true;
    },
  },
  data() {
    return {
      age: null,
      gender: '',
      height: null,
      weight: null,
      activity: '',
      goal: '',
      displayFields: false
    }
  }
}
</script>

